import create from "zustand";
export var useToolbarMetricsStore = create(function (set) { return ({
    movementCount: 0,
    addMovementCount: function () {
        return set(function (state) { return ({ movementCount: state.movementCount + 1 }); });
    },
    collapsedDuration: 0,
    addCollapsedDuration: function (duration) {
        return set(function (state) { return ({ collapsedDuration: state.collapsedDuration + duration }); });
    },
    lastCollapsedTimestamp: undefined,
    setLastCollapsedTimestamp: function (timestamp) {
        return set(function () { return ({ lastCollapsedTimestamp: timestamp }); });
    },
    expandButtonClickCount: 0,
    addExpandButtonClickCount: function () {
        return set(function (state) { return ({
            expandButtonClickCount: state.expandButtonClickCount + 1,
        }); });
    },
    expandHandleClickCount: 0,
    addExpandHandleClickCount: function () {
        return set(function (state) { return ({
            expandHandleClickCount: state.expandHandleClickCount + 1,
        }); });
    },
    collapseButtonClickCount: 0,
    addCollapseButtonClickCount: function () {
        return set(function (state) { return ({
            collapseButtonClickCount: state.collapseButtonClickCount + 1,
        }); });
    },
    collapseHandleClickCount: 0,
    addCollapseHandleClickCount: function () {
        return set(function (state) { return ({
            collapseHandleClickCount: state.collapseHandleClickCount + 1,
        }); });
    },
}); });
